import Box from "@mui/material/Box";
import { usePageContext } from "vike-react/usePageContext";
import { Header } from "./Header";
import { InterestWidget } from "./InterestWidget";
import { rootSx } from "./Layout.sx";
import { useFixedViewportHeight } from "../../theme/useFixedViewportHeight";
// Initialize GSAP ScrollTrigger config (ignoreMobileResize to prevent address bar jumping)
import "../../theme/gsapConfig";

// Routes that should use dark mode header
const DARK_MODE_ROUTES = [
  "/portfolio",
  "/career",
  "/team",
  "/our-journey",
  "/terms-of-service",
  "/privacy-policy",
];

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { urlPathname, is404 } = usePageContext();
  const isDarkMode =
    !is404 &&
    DARK_MODE_ROUTES.some((route) => urlPathname.startsWith(route));
  const isPortfolioPage = urlPathname === "/portfolio";
  const isTeamPage = urlPathname === "/team";

  // Set fixed viewport height CSS variable to prevent mobile address bar jumping
  useFixedViewportHeight();

  return (
    <Box sx={rootSx}>
      <Header
        isDarkMode={isDarkMode}
        isPortfolioPage={isPortfolioPage}
        isTeamPage={isTeamPage}
      />
      <InterestWidget />
      <Box component="main">{children}</Box>
    </Box>
  );
}

export default Layout;
